export const TrackIcon = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      fill="#2E7D32"
    />
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      stroke="#E5E7EB"
    />
    <path
      d="M23 23C23 22.1703 22.3297 21.5 21.5 21.5C20.6703 21.5 20 22.1703 20 23V38.75C20 40.8219 21.6781 42.5 23.75 42.5H42.5C43.3297 42.5 44 41.8297 44 41C44 40.1703 43.3297 39.5 42.5 39.5H23.75C23.3375 39.5 23 39.1625 23 38.75V23ZM42.0594 27.0594C42.6453 26.4734 42.6453 25.5219 42.0594 24.9359C41.4734 24.35 40.5219 24.35 39.9359 24.9359L35 29.8766L32.3094 27.1859C31.7234 26.6 30.7719 26.6 30.1859 27.1859L24.9359 32.4359C24.35 33.0219 24.35 33.9734 24.9359 34.5594C25.5219 35.1453 26.4734 35.1453 27.0594 34.5594L31.25 30.3734L33.9406 33.0641C34.5266 33.65 35.4781 33.65 36.0641 33.0641L42.0641 27.0641L42.0594 27.0594Z"
      fill="white"
    />
  </svg>
);

export default TrackIcon;
